module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/cases/css/settings.component.css
// module id = ./src/app/modules/cases/css/settings.component.css
// module chunks = main